import axios from 'axios';
import store from '../store';
const IGNORE_URL = ['/login'];
export default function () {
    //添加用户登录认证的拦截器
    axios.interceptors.response.use(
        response => {
            return response
        },
        error => {
            if (error.response) {
                let {$router, $store} = window.app;

                if (IGNORE_URL.indexOf(error.response.config.url) < 0) {
                    switch (error.response.status) {
                        case 401:
                            $store.commit('removeUser')
                            if ($router.currentRoute.name !== 'login') {
                                $router.replace({
                                    name: 'login',
                                    query: {redirect: $router.currentRoute.fullPath}
                                })
                            }
                            break
                    }
                }
            }
            return Promise.reject({
                message: error.response.data.msg
            })   // 返回接口返回的错误
        }
    );
    axios.interceptors.request.use(
        config => {
            config.headers['Authorization'] = store.state.token;
            return config;
        }
    )
}
